<template>
    <div class="container">
        <TitleInfo title="技能课程" :tip="tip1" icon="one-live"  v-if="classListInfo.moduleNumbers.course"></TitleInfo>
        <div class="items">
            <EntCourseItem :items="classListInfo.results" v-if="!$router.currentRoute.query.keyword"/>
            <ClassSearchResult :items="classListInfo.results" v-if="$router.currentRoute.query.keyword"/>
            <Waiting v-if="!classListInfo.moduleNumbers.course&&!loading" tips="没有找到相关技能课程～"/>
        </div>
        <Page :total="classListInfo.moduleNumbers.course"
              v-if="classListInfo.moduleNumbers.course"
              :current="filterParams.pageIndex*1"
              :page-size="filterParams.pageSize"
              @on-change="handlePageIndexChanged"/>



    </div>
</template>

<script>
    import api from '@/api/calss-search'
    import EntCourseItem from "../components/EntCourseItem";
    import ClassSearchResult from "../components/ClassSearchResult";
    import Empty from "../../class-search-result/empty"
    import Waiting from "../../service-center/Waiting"
    import TitleInfo from "../components/TitleInfo";

    export default {
        name: "SkillCourse",
        data() {
            return {
                loading:false,
                tip1:'授人以鱼不如授人以渔，在这里，我们解读了企法中台数据库中给大家准备的"内容弹药"背后的方法和原理，帮助大家提升市场拓展技能，掌握个性化修订方法。',
                filterParams: {
                    query: this.$router.currentRoute.query.keyword,
                    pageIndex: this.$router.currentRoute.query.pageIndex||1,
                    pageSize: 6,
                    searchType: 'course',
                    secondType:'skillCourse'
                },
                classListInfo:{
                    results:[],
                    moduleNumbers:{},
                    courseTotal:0,
                },
                totalCount: 0,
                searchTitle: '',
                pageIndex: 0,
                courses: []
            }
        },
        watch: {
            $route(to, from) {
                this.filterParams.query = this.$router.currentRoute.query.keyword
                this.filterParams.pageIndex = this.$router.currentRoute.query.pageIndex||1
                this.filterParams.pageSize = 6
                this.queryList()
            }
        },
        components: {EntCourseItem,Empty,ClassSearchResult,TitleInfo,Waiting},
        methods: {
            // 查询数据
            async queryList() {
                this.loading = true
                api.classSearchList(this.filterParams).then(res => {
                    this.loading = false
                    this.classListInfo = res
                }).finally(() => {
                    this.loading = false
                })
            },
            handlePageIndexChanged(index) {
                this.filterParams.pageIndex = index;
                this.$router.push(`${this.$router.currentRoute.path}?keyword=${this.$router.currentRoute.query.keyword||''}&pageIndex=${index}`)
            }
        },
        mounted() {
            this.queryList();
            window.scrollTo(0, 0)
        }
    }
</script>

<style scoped lang="scss">
    .container {
        width: 1000px;
        padding: 40px 0px 40px 0px;
        margin-left: 45px;
    }
    .totalCount {
        height: 20px;
        margin-left: 10px;
        font-family: PingFangSC;
        font-size: 14px;
        margin-bottom: 32px;
        color: #4a4a4a;
    }
    .items{
        overflow: hidden;
        margin-bottom: 20px;
    }
    .pagination {
        clear: both;
    }
</style>
